import React from 'react';
import { Slide1Cover, Slide2ExecutiveSummary, Slide3Founders, Slide4WhatsBuilt, Slide5DesignArsenal } from './components/Slides1To5';
import { Slide6MarketOpportunity, Slide7RevenueEcosystem, Slide8WhyNow, Slide9CompetitiveAdvantages, Slide10TeamStructure } from './components/Slides6To10';
import { Slide11StrategicLocation, Slide12RolloutPlan, Slide13FinancialModel, Slide14UseOfFunds } from './components/Slides11To15';
export function App() {
  return <main className="bg-white min-h-screen w-full selection:bg-black selection:text-white" data-id="element-0">
      <Slide1Cover data-id="element-1" />
      <Slide2ExecutiveSummary data-id="element-2" />
      <Slide3Founders data-id="element-3" />
      <Slide4WhatsBuilt data-id="element-4" />
      <Slide5DesignArsenal data-id="element-5" />

      <Slide6MarketOpportunity data-id="element-6" />
      <Slide7RevenueEcosystem data-id="element-7" />
      <Slide8WhyNow data-id="element-8" />
      <Slide9CompetitiveAdvantages data-id="element-9" />
      <Slide10TeamStructure data-id="element-10" />

      <Slide11StrategicLocation data-id="element-11" />
      <Slide12RolloutPlan data-id="element-12" />
      <Slide13FinancialModel data-id="element-13" />
      <Slide14UseOfFunds data-id="element-14" />
    </main>;
}